// Cantidades en milésimas enteras: 1 unidad = 1000. 250 g de un producto por kg = 250.

export const MILLI = 1000;

export const UNIT_TYPES = {
  unit: { label: 'Unidad', symbol: 'u', fractional: false },
  weight: { label: 'Peso (kg)', symbol: 'kg', fractional: true },
  volume: { label: 'Volumen (l)', symbol: 'l', fractional: true },
  length: { label: 'Longitud (m)', symbol: 'm', fractional: true },
} as const;

export type UnitType = keyof typeof UNIT_TYPES;

export function toMilli(quantity: number): number {
  return Math.round(quantity * MILLI);
}

export function formatQty(milli: number, unitType: UnitType = 'unit'): string {
  const def = UNIT_TYPES[unitType];
  const value = milli / MILLI;
  const text = new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: def.fractional ? 3 : 0,
  }).format(value);
  return unitType === 'unit' ? text : `${text} ${def.symbol}`;
}

/** "1,5" → 1500 · "0.250" → 250 · "3" → 3000. Devuelve null si es inválido. */
export function parseQty(input: string, unitType: UnitType = 'unit'): number | null {
  const s = input.trim().replace(',', '.');
  if (!/^\d+(\.\d{1,3})?$/.test(s)) return null;
  const milli = toMilli(Number(s));
  if (!UNIT_TYPES[unitType].fractional && milli % MILLI !== 0) return null;
  return milli;
}
